module.exports = __webpack_public_path__ + "img/43.98bfa69c.jpg";